import React, { useState } from "react";
import { Collapsible } from "../../components";
import { AppInviteForm, EventsForm } from "./events";

const STEPS = {
  EMAIL_STEP: "Email",
  EVENT_STEP: "Events",
  INVITE_STEP: "APP INVITE",
};

const ActivityTab = ({ user, afterSubmit }) => {
  const [step, setStep] = useState(null);

  return (
    <div className="kyc">
      <Collapsible trigger="Email" open={step === STEPS.EMAIL_STEP}>
        Email
      </Collapsible>

      <Collapsible trigger="Events" open={step === STEPS.EMAIL_STEP}>
        <EventsForm user={user} />
      </Collapsible>

      <Collapsible trigger="APP INVITE" open={step === STEPS.INVITE_STEP}>
        <AppInviteForm user={user} />
      </Collapsible>
    </div>
  );
};

export default ActivityTab;
